import { render, staticRenderFns } from "./TransferDialog.vue?vue&type=template&id=0430dc24&scoped=true"
import script from "./TransferDialog.ts?vue&type=script&lang=ts&external"
export * from "./TransferDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./TransferDialog.vue?vue&type=style&index=0&id=0430dc24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0430dc24",
  null
  
)

export default component.exports